import amaLog from '../helpers/log';
import { resolveCountryCode } from '../config/domain';

const statsCollectorAdsEndpoint = `${process.env.ADS_STATS_COLLECTOR}`;

interface Stats {
  clientTsInMs: number;
  site: string;
  stats: any[];
}

interface SiteMapping {
  [key: string]: string;
}

const siteMapping: SiteMapping = {
  residencemagazine: 'residence',
  femina:  resolveCountryCode() === 'dk' ? 'feminadk' : 'femina',
};

const getSiteFromDomain = (site: string): string => siteMapping[site] ?? site;

export function AdStats(site: string) {
  let _site = getSiteFromDomain(site);
  let _stats: any[] = [];

  const add = (stats: any[]): any[] => {
    if (Array.isArray(stats) && stats.length) {
      _stats = [..._stats, ...stats];
    }
    return _stats;
  };

  const payload = (): Stats => ({
    clientTsInMs: Date.now(),
    site: _site,
    stats: [..._stats],
  });

  const toJSON = (): string | undefined => {
    try {
      const response = JSON.stringify(payload());
      return response;
    } catch (e) {}
  };

  const appendFromJSON = (payload: string): void => {
    const parsed = JSON.parse(payload);
    _stats = [..._stats, ...parsed.stats];
  };

  const push = (): void => {
    if (_stats.length) {
      // TODO: Need to improve this bit to make sure we don't get corrupt data
      const body = toJSON();
      if (body) {
        _stats = [];
        // GCP ENDPOINT
        fetch(statsCollectorAdsEndpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          body,
        }).catch(() => {
          amaLog(`AdStats::push - Unable to push stats to GCP, re-adding.`);
          appendFromJSON(body);
        });
      } else {
        amaLog(`AdStats::push - unable to retrieve retrieve payload..`);
      }
    }
  };

  return {
    all: (): any[] => _stats,
    add,
    push,
    toJSON,
    payload,
  };
}
